import dynamic from "next/dynamic";
import {
  viewport,
  colors,
  font,
  lineHeight,
} from "../../../styles/cssinjs/helpers/variables.js";

import CarouselControls from "@components/molecules/common/CarouselControls";
const VideoModal = dynamic(() => import("./VideoModal"));

export default function VideoCards({
  data,
  toggleVideo,
  isVideoModalVisible,
  videoId,
}) {
  // Elements
  const PlayButton = ({ id }) => {
    return (
      <button
        className="play-btn"
        aria-label="Play Video Button"
        onClick={(e) => {
          let id = e.target.closest(".play-btn").id;
          toggleVideo(id);
        }}
        id={id}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 80 80"
          width="80"
          height="80"
        >
          <g fill="none">
            <circle
              cx="40"
              cy="40"
              r="38"
              fill="#000"
              fillOpacity=".25"
              stroke="#FFF"
              strokeWidth="4"
            ></circle>
            <path
              fill="#FFF"
              d="M32 55.73c0 1.696 1.978 2.622 3.28 1.536l18.876-15.73c.96-.8.96-2.273 0-3.072L35.28 22.734c-1.302-1.086-3.28-.16-3.28 1.536v31.46z"
            ></path>
          </g>
        </svg>
      </button>
    );
  };
  const Video = ({ data }) => {
    return (
      <video
        autoPlay
        muted
        loop
        poster={data.preview}
        preload="none"
        playsInline
      >
        <source src={data.thumbnail} type="video/mp4" />
      </video>
    );
  };

  const VideoCards = () => {
    return data.map((item, count) => {
      return (
        <li className="carousel-item" key={count}>
          <div
            className="video-highlight"
            style={{ height: "auto", width: "auto" }}
          >
            <a className="video-timg">
              <Video data={item.video} />
              <PlayButton id={item.video.id} />
            </a>
          </div>
          <div className="content">
            <h3>
              <p>{item.title}</p>
            </h3>
          </div>
          <style jsx>{`
            .content {
              padding: 24px 24px 32px;
            }
            h4 * {
              font-size: ${font.size.md[3]}!important;
            }
            .video-highlight {
              margin-top: 0px !important;
            }
            @media (max-width: ${viewport.tablet.sm}) {
              .carousel-item {
                min-width: 300px;
              }
              .content {
                padding: 20px 20px 24px;
              }
              .video-highlight {
                height: auto !important;
              }
            }
          `}</style>
        </li>
      );
    });
  };

  const ViewMoreCards = () => {
    return (
      <li className="carousel-item">
        <a
          href="https://www.youtube.com/user/SetMoreAppointments"
          className="fx fx--ch fx--cv"
        >
          <span className="text-brandcolor fw-700">Watch more videos</span>
        </a>
        <style jsx>{`
          a {
            height: 100%;
            width: 100%;
          }
          span {
            font-size: ${font.size.md[2]};
            line-height: ${lineHeight[7]};
          }
        `}</style>
      </li>
    );
  };

  return (
    <>
      {isVideoModalVisible ? (
        <VideoModal toggleVideo={toggleVideo} videoId={videoId} />
      ) : (
        ""
      )}
      <div className="carousel-cont">
        <ul className="carousel fx card--default">
          <VideoCards />
          <ViewMoreCards />
        </ul>
        <CarouselControls totalCarousels={data.length} />
      </div>
      <style global jsx>{`
        .carousel-cont {
          -ms-overflow-style: none;
          scrollbar-width: none;
          padding: 10px 0px;
        }
        .carousel-item {
          min-width: 360px;
        }

        .carousel-cont::-webkit-scrollbar {
          display: none;
        }
        .carousel {
          gap: 40px;
          flex-wrap: nowrap;
          justify-content: flex-start;
          transform: none;
        }
        @media (max-width: ${viewport.desktop.sm}) {
          .carousel {
            transform: translateX(20px);
          }
          .carousel-cont .card--default > * {
            max-width: 295px;
          }
        }
        @media (max-width: ${viewport.tablet.sm}) {
          .carousel-item {
            min-width: 295px;
          }
          .carousel {
            min-height: initial;
            gap: 20px;
            width: ${(data.length + 1) * 300 +
            20 * (data.length + 1)}px !important;
          }
        }
      `}</style>
    </>
  );
}
